const { h, render, Component } = require('preact');

class Radio extends Component {
  constructor(props) {
    super(props);
    this.changeRadioState = this.changeRadioState.bind(this)
    this.isInputValid = this.isInputValid.bind(this)
  }

  changeRadioState() {
    this.props.updateState(this.props.attrs.type, this.props.attrs.counter, this.populateInput(), this.isInputValid())
  }

  getRadioOptions(options) {
    var currentObjectCount, radioOptionKey, radioOptionPayload, radioOptions;
    radioOptions = [];
    var count =  0
    for (radioOptionKey in options) {
      radioOptionPayload = options[radioOptionKey];
      currentObjectCount = ++count;
      if (radioOptionPayload.value.length > 0) {
        radioOptions.push({
          id: radioOptionPayload.value,
          text: radioOptionPayload.key,
          radioCounter: currentObjectCount
        });
      } else {
        radioOptions.push({
          id: radioOptionPayload.key,
          text: radioOptionPayload.key,
          radioCounter: currentObjectCount
        });
      }
    }
    return radioOptions;
  }

  getInputInvalidMsgElement() {
    return document.getElementById("radioInputInvalidMsgID")
  }

  checkInput() {
    return document.querySelector('input[name=radio_'+this.props.attrs.counter +']:checked').checked;
  }

  isInputGiven() {
    return this.isInputValid()
  }

  readInput() {
    if (document.querySelector('input[name=radio_'+this.props.attrs.counter +']:checked')) {
      return document.querySelector('input[name=radio_'+this.props.attrs.counter +']:checked').value
    }
    else
      return null
  }

  isInputValid() {
    if (this.props.attrs.required)
      return this.checkInput()
    return true
  }

  validateInput() {
    var showInvalidInputMsg = this.props.attrs.required && !this.checkInput()
    if (showInvalidInputMsg)
      this.getInputInvalidHtmlElement().style.display = 'block'
    else
      this.getInputInvalidHtmlElement().style.display = 'none'
    return
  }

  componentDidMount() {
    var radioElements = document.getElementsByClassName('cooling_off_radio')
    for (let i = 0; i < radioElements.length; i++) {
      radioElements[i].addEventListener('change', this.changeRadioState)
    }
  }

  populateInput() {
    var inputData = this.readInput()
    var data = {}
    data.description = `\n\n ${this.props.attrs.label} : ${inputData}`
    return data
  }

  render() {
      var attrs = this.props.attrs
      var radioOptions = this.getRadioOptions(attrs.additional_attributes.options);
      return (
        <div>
          <label>
            <strong>{attrs.label}</strong>
            {attrs.required ? (<span class="mandatory-field"> * </span>) : null}
          </label>

          {radioOptions.map((item, i) =>
            <div>
              <input type="radio" class="cooling_off_radio" name={"radio_" + attrs.counter} data-bhw={'radio_input' + item.radioCounter}
                     id={'radio_input' + item.radioCounter} value={'radio_input' + item.radioCounter}/>
              <label for={'radio_input' + item.radioCounter}>
                <span><strong>{item.text}</strong></span></label>
            </div>
          )
          }
        </div>
      )
    }
  }

module.exports = Radio
